import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const endpoint = "SeatMap";

/** A club's seating plan: the drawing, and which block is which. */
export const SeatMapService = {
	endpoint,
	get: async (venueId: number) =>
		await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Venue/${venueId}`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	// No Content-Type: the browser sets the multipart boundary itself, and
	// overriding it makes the upload unparseable at the other end.
	upload: async (venueId: number, form: FormData) =>
		await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Venue/${venueId}/Upload`, {body: form, method: "POST"}),
	setUrl: async (venueId: number, svgUrl: string) =>
		await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Venue/${venueId}/Url`, {body: JSON.stringify(svgUrl), headers: {"Content-Type": "application/json"}, method: "POST"}),
	map: async (venueId: number, mappings: any[]) =>
		await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Venue/${venueId}/Map`, {body: JSON.stringify(mappings), headers: {"Content-Type": "application/json"}, method: "POST"})
};
